import styled from '@emotion/styled';

export const Banner = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: #232323;
	color: #fff;
	padding: 20px;
	border-radius: 8px;
	font-size: 14px;
	margin-bottom: 20px;
	width: 100%;
	max-width: 1296px;

	@media screen and (max-width: 991px) {
		width: calc(100% - 32px);
		margin: 16px 0;
		padding: 16px;
		font-size: 12px;
	}
`;

export const Message = styled.span`
	display: flex;
	align-items: center;
	column-gap: 10px;
	color: #fff;

	& svg {
		flex-shrink: 0;
	}
`;

export const CloseButton = styled.button`
	background: transparent;
	border: none;
	color: #fff;
	font-weight: bold;
	cursor: pointer;
	font-size: 14px;
	padding: 0;
	font-family: inherit;
`;
